import {PostUpdateComponent} from '$components/posts/post-update/post-update.component';
import {LoginPageComponent} from '$pages/login/login-page.component';
import {AuthService} from '$services/auth/auth.service';
import {ConfirmService} from '$services/confirm.service';
import {IconsService} from '$services/icons/icons.service';
import {PostsService} from '$services/posts/posts.service';
import {HorseDTO, HorseSex, PostDisplay, PostDTO, PostStatus, PostWithDatasDTO, UpdatePostForm, User} from '$types';
import {DatePipe} from '@angular/common';
import {AfterViewInit, Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {ActivatedRoute, Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {Observable, Observer, Subscription} from 'rxjs';
import {CreateUpdateComponent} from './crud/create-update/create-update.component';
import {WarningPopupComponent} from './warning-popup/warning-popup.component';
import {EventBusService} from "$services/auth/event/event-bus.service";
import {MatSelect} from "@angular/material/select";

@Component({
    selector: 'app-page-posts',
    templateUrl: './posts-page.component.html',
    styleUrls: ['./posts-page.component.css'],
})
export class PostsPageComponent implements OnInit, OnDestroy, AfterViewInit {
    postLayout!: boolean;
    scrollLoad: boolean = false;
    postSubscription: Subscription = new Subscription();
    updateSubscription = new Subscription();
    loadingSubscription: Subscription = new Subscription();
    orderSubscription = new Subscription();
    loading: boolean = true;
    @ViewChild('sortSelect') sortSelect!: MatSelect;

    @ViewChild(MatSort) set matSort(sort: MatSort) {
        this.dataSource.sort = sort;
    }

    posts: PostDisplay[] = [];
    postsDisplay: PostDisplay[] = [];
    dataSource: MatTableDataSource<PostDisplay> =
        new MatTableDataSource<PostDisplay>();
    user?: User | null;

    displayedColumns: string[] = [];
    activeFilter!: boolean;
    el: ElementRef;

    constructor(
        private readonly confirmService: ConfirmService,
        private readonly dialog: MatDialog,
        private readonly authService: AuthService,
        private readonly eventBusService: EventBusService,
        private readonly postsService: PostsService,
        private readonly route: ActivatedRoute,
        private readonly snackBar: MatSnackBar,
        private readonly translateService: TranslateService,
        private readonly router: Router,
        private readonly icons: IconsService,
        private readonly datepipe: DatePipe,
        el: ElementRef
    ) {
        this.icons.registerIcon([`filter`, `file-plus`])
        this.user = this.authService.user;
        this.el = el;
        const notLoggedColumns = [
                'published_at',
                'horse_name',
                'horse_sex',
                'horse_age',
                'horse_record',
                'horse_total_earn',
                'horse_sell_price',
                'to_negociate',
                'horse_category',
            ],
            loggedColumns = [
                'published_at',
                'horse_name',
                'horse_sex',
                'horse_age',
                'horse_record',
                'horse_total_earn',
                'horse_sell_price',
                'to_negociate',
                'horse_category',
                'expire_at',
                'status',
                'actions',
            ],
            moderatorColumns = [
                'horse_name',
                'validated_at',
                'published_at',
                'expire_at',
                'payment_method',
                'status',
                'actions',
            ];
        if (this.user?.roles) {
            if (this.user.moderator) {
                this.displayedColumns = moderatorColumns;
            } else {
                this.displayedColumns = loggedColumns;
            }
        } else {
            this.displayedColumns = notLoggedColumns;
        }
    }

    ngAfterViewInit(): void {

    }

    ngOnDestroy(): void {
        this.postSubscription.unsubscribe();
        this.loadingSubscription.unsubscribe();
        this.orderSubscription.unsubscribe();
        this.updateSubscription.unsubscribe();
    }

    get moderatorMode(): boolean {
        return this.user?.moderator ?? false;
    }

    // TODO: Fix messages which are not translated for some reason
    get success_payment_message() {
        return this.translateService.instant('success.payment');
    }

    get failure_payment_message() {
        return this.translateService.instant('errors.payment');
    }

    getFormattedDate(date: Date) {
        if (!date) return;

        return this.datepipe.transform(date, 'dd/MM/YYYY')
    }

    getHorseAge(horse: HorseDTO) {
        return new Date().getFullYear() - horse.birthYear;
    }

    getSexAbbreviation(sex: HorseSex) {
        return sex.at(0);
    }

    getPaymentMethod(post: PostDTO) {
        if (!post.payments) return;
        return post.payments.at(-1)?.method;
    }

    ngOnInit(): void {
        this.loading = this.postsService.loading;
        this.postsService.page = 0;
        this.loadingSubscription = this.postsService.loadingChanged.subscribe(value => this.loading = value);
        this.postSubscription = this.postsService.postChanged.subscribe(this.processAllPost());
        this.updateSubscription = this.postsService.postUpdated.subscribe(updatedPost => {
          const index = this.posts.findIndex(post => post.id === updatedPost.id);
          if(index !== -1){
            this.posts[index] = updatedPost;
            this.postsDisplay = this.posts;
          }
        });
        this.route.queryParams.subscribe(params => {
            let horseName = params["horse-name"];
            let orderBy = params["order-by"];
            let status = params["status"];
            let category = params["category"];
            let author = params["author"];
            if(this.isUndefinedOrEmpty(horseName)
                && this.isUndefinedOrEmpty(orderBy)
                && this.isUndefinedOrEmpty(status)
                && this.isUndefinedOrEmpty(category)
                && this.isUndefinedOrEmpty(author)){
                this.getAllPosts();
            }
        });
        if (!this.authService.hasWatchedPopup(WarningPopupComponent.version)) {
            // ajout d'une pop-up Avertissement
            this.dialog.open(WarningPopupComponent, {
                panelClass: 'login-modalbox'
            });

        }
        this.activeFilter = false;
        this.route.queryParams.subscribe(
            (params) => {
                const successful_payment = params['successful_paid'];
                if (successful_payment) {
                    const is_successful_payment = successful_payment === 'true';
                    const message = is_successful_payment
                        ? this.success_payment_message
                        : this.failure_payment_message;
                    const background_color = is_successful_payment
                        ? 'bg-green'
                        : 'bg-red';
                    const snackbar = this.snackBar.open(message, 'Ok', {
                        duration: 5000,
                        verticalPosition: 'top',
                        panelClass: [background_color],
                    });
                    snackbar.afterDismissed().subscribe(() => {
                        this.router.navigate(['/posts']);
                    });
                }
            }
        );
        this.eventBusService.on(
            'login', (action: any) => {
                this.postsService.getPosts().length = 0;
                this.postsService.changeLoadingState(true);
                this.postsService.page = 0;
                this.postsService.get().subscribe(() => {
                });
            }
        );
        this.orderSubscription = this.postsService.orderPost.subscribe(value =>{
            setTimeout(() => {
                this.sortSelect.value = value;
            },300);
        });
    }

    isUndefinedOrEmpty(value:string){
        return !value || value.trim().length === 0;
    }

    @HostListener('scroll', ['$event'])
    onScroll(event: any): void {
        if ((this.postsService.page != -1) && (event.target.offsetHeight + event.target.scrollTop >= event.target.scrollHeight - 10)) {
            this.getPaginatedData();
        }
    }

    getPaginatedData() {
        //Paginate;
        this.postsService.page = this.postsService.page + 1;
        this.scrollLoad = true;
        this.postsService.getNextPostPage(this.postsService.page).subscribe(posts => {
            if (posts.length === 0) {
                this.postsService.page = -1;
            }
            this.removeArchived(posts).forEach(post => this.posts.push(post));
            this.postsDisplay = this.posts;
            this.scrollLoad = false;
        });
    }

    removeArchived(posts: PostDisplay[]) {
        let res: PostDisplay[] = [];
        for (let post of posts) {
            if (post.status !== PostStatus.ARCHIVED) {
                res.push(post);
            }
        }
        return res;
    }

    sortChange() {
        this.postsService.emitOrderPost(this.sortSelect.value);
    }

    renouvelePost(id: string) {
        this.postsService.renouvele(id);
    }

    validatePost(postToValidate: PostWithDatasDTO) {
        if (postToValidate.admin?.free) {
            this.proceedToValidationNormalMode(postToValidate.id)
            //this.proceedToValidationAdminMode(postToValidate.id) //TODO: change this when payment fixed
        } else {
            this.proceedToValidationNormalMode(postToValidate.id)
        }
    }

    proceedToValidationAdminMode(id: string) {
        this.confirmService
            .ConfirmDialog(this.translateService.instant('posts.freeValidation.title'), this.translateService.instant('posts.freeValidation.text'))
            .subscribe((status) => {
                if (!status) {
                    return
                }
                this.postsService.validateFree(id).subscribe((post) => {
                    this.getAllPosts();
                })
            });
    }

    proceedToValidationNormalMode(id: string) {

        this.confirmService
            .ConfirmDialog(this.translateService.instant('posts.validation.title'), this.translateService.instant('posts.validation.text'))
            .subscribe((status) => {
                if (!status) {
                    return
                }
                this.postsService.validate(id).subscribe((post) => {
                    this.getAllPosts();
                })
            });
    }

    getAllPostsOrderedBy(sort: string) {
        this.postsService.getAndOrderBy(sort).subscribe(this.processAllPost())
    }

    getAllPosts() {
        if (this.postsService.getPosts().length === 0) {
            this.postsService.get().subscribe(() => {
            });

        } else {
            this.posts = this.postsService.getPosts();
            this.postsDisplay = this.posts;
            this.postsService.changeLoadingState(false);
        }
    }

    private processAllPost(): Partial<Observer<PostDisplay[]>> {
        return {
            next: posts => {
                this.posts = posts;
                if(!this.authService.isLogged() || this.postsService.page !== -1){
                    this.posts = posts.filter(
                        (post) => post.status !== PostStatus.ARCHIVED
                    );
                }
                this.postsService.changeLoadingState(false);
                this.postsDisplay = this.posts;
                this.dataSource.data = this.posts;
                if (this.posts.length < 10 && this.postsService.page !== -1) {
                    this.getPaginatedData();
                }
            },
            error: err => {
                console.error('une erreur est survenue', err);
                this.snackBar.open('⚠ : une erreur est survenue', 'x', {
                    duration: 5000,
                    verticalPosition: 'top',
                    panelClass: ['bg-red'],
                });
            }
        };
    }

    creerNouvelleAnnonce() {

        if (this.notLogged()) {
            this.afficherEcranLogin().subscribe((x) => this.creerNouvelleAnnonce());
        } else {
            this.afficherEcranNouvelleAnnonce();
        }
    }

    afficherEcranNouvelleAnnonce() {
        const dialogRef = this.dialog.open(CreateUpdateComponent, {
            panelClass: 'login-modalbox'
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                this.postsService.create(result).subscribe({
                    next: _post => {
                        this.getAllPosts();
                    }
                });
            }
            this.getAllPosts();
        });
    }

    afficherEcranLogin(): Observable<void> {
        return this.dialog
            .open(LoginPageComponent, {
                panelClass: 'login-modalbox'
            })
            .afterClosed();
    }

    notLogged(): boolean {
        return !this.authService.isLogged();
    }

    updatePost(originalDoc: PostDisplay) {
        const dialogRef = this.dialog.open(PostUpdateComponent, {
            data: {
                id: originalDoc.id,
            },
        });

        dialogRef.afterClosed().subscribe((result: UpdatePostForm) => {
            if (result) {
                this.postsService.update(result, originalDoc).subscribe((post) => {
                    this.getAllPosts();
                });
            }
        });
    }

    invalidatePost(id: string) {
        this.confirmService
            .ConfirmDialog(this.translateService.instant('posts.invalidate.title'), this.translateService.instant('posts.invalidate.text'))
            .subscribe((status) => {
                if (!status) {
                    return
                }
                this.postsService.invalidate(id).subscribe((post) => {
                    this.getAllPosts();
                });
            });
    }

    deletePost(id: string) {
        this.confirmService
            .ConfirmDialog(this.translateService.instant('posts.delete.title'), this.translateService.instant('posts.delete.text'))
            .subscribe((status) => {
                if (!status) {
                    return
                }
                this.postsService.delete(id).subscribe(() => {
                    this.getAllPosts();
                });
            });
    }

    renewPost(id: string) {
        this.confirmService
            .ConfirmDialog(this.translateService.instant('posts.renew.title'), this.translateService.instant('posts.renew.text'), this.translateService.instant('posts.renew.button1'), this.translateService.instant('posts.renew.button2'))
            .subscribe((status) => {
                if (!status) {
                    return
                }
                this.router.navigate(['/renew'],
                    {queryParams: {id: id}});
            });
    }

    combine(
        newPost: PostDTO | null
    ): (post: PostWithDatasDTO) => PostWithDatasDTO {
        return (post: PostWithDatasDTO): PostWithDatasDTO => {
            if (post.id === newPost?.id) {
                return {...post, ...newPost};
            }
            return post;
        };
    }

    toggleOpenFilter() {
        this.activeFilter = !this.activeFilter;
    }

    postLayoutToggle($event: boolean) {
        this.postLayout = $event
    }

    postFiltereded($event: PostDisplay[]) {

        this.posts = $event.filter(
            (post) => post.status !== PostStatus.ARCHIVED
        );

        this.postsDisplay = this.posts
        this.dataSource.data = this.posts;
    }
}

